import { GOVT_ID_ERROR_CODES } from 'features/govtId/v2/helper/constants';

export const FAILURE_BUCKETS = {
    COULDNT_READ: 'couldnt_read',
    BLURRY: 'blurry',
    LIVENESS_FAILED: 'liveness_failed',
    AUTHENTICITY_FAILED: 'authenticity_failed',
    EXPIRED: 'expired',
    DATA_INVALID: 'data_invalid',
    NOT_ACCEPTED: 'not_accepted',
    EXHAUSTED: 'exhausted',
    FAILED_OTHER: 'failed_other',
    TECHNICAL: 'technical',
};

// Error codes the backend records when it gives up on a Regula result.
const GIVE_UP_ERROR_CODES = {
    RESULT_FETCH_FAILED: 'result_fetch_failed',
    RESULT_MAPPING_FAILED: 'result_mapping_failed',
};

// Must stay identical to the backend's ProductAnalyticV2 failure-bucket table, so hosted-ui and
// backend events break down the same way.
export const CODES_BY_BUCKET = {
    [FAILURE_BUCKETS.COULDNT_READ]: [
        GOVT_ID_ERROR_CODES.DOCUMENT_FRONT_NOT_READABLE,
        GOVT_ID_ERROR_CODES.DOCUMENT_BACK_NOT_READABLE,
        GOVT_ID_ERROR_CODES.DOC_FORMAT_MISMATCH,
        GOVT_ID_ERROR_CODES.DL_BACK_IMAGE_REQUIRED,
    ],
    [FAILURE_BUCKETS.BLURRY]: [
        GOVT_ID_ERROR_CODES.IMAGE_NOT_VALID,
        GOVT_ID_ERROR_CODES.CAPTURE_QUALITY_FAILED,
    ],
    [FAILURE_BUCKETS.LIVENESS_FAILED]: [GOVT_ID_ERROR_CODES.DOCUMENT_LIVENESS_FAILED],
    [FAILURE_BUCKETS.AUTHENTICITY_FAILED]: [
        GOVT_ID_ERROR_CODES.TAMPER_CHECK_FAILED,
        GOVT_ID_ERROR_CODES.AUTHENTICITY_CHECK_FAILED,
        GOVT_ID_ERROR_CODES.DOCUMENT_NOT_PASSED,
    ],
    [FAILURE_BUCKETS.EXPIRED]: [GOVT_ID_ERROR_CODES.DOCUMENT_EXPIRED],
    [FAILURE_BUCKETS.DATA_INVALID]: [
        GOVT_ID_ERROR_CODES.INVALID_DOB,
        GOVT_ID_ERROR_CODES.INVALID_NAME,
        GOVT_ID_ERROR_CODES.DOCUMENT_DATA_MISMATCH,
    ],
    [FAILURE_BUCKETS.NOT_ACCEPTED]: [
        GOVT_ID_ERROR_CODES.RESTRICTED_DOC_TYPE,
        GOVT_ID_ERROR_CODES.TYPE_NOT_SUPPORTED,
        GOVT_ID_ERROR_CODES.UNSUPPORTED_DOCUMENT_TYPE,
        GOVT_ID_ERROR_CODES.RESTRICTED_COUNTRY,
        GOVT_ID_ERROR_CODES.VERIFICATION_NOT_ENABLED,
    ],
    [FAILURE_BUCKETS.EXHAUSTED]: [GOVT_ID_ERROR_CODES.ATTEMPTS_EXHAUSTED],
    [FAILURE_BUCKETS.TECHNICAL]: [
        GIVE_UP_ERROR_CODES.RESULT_FETCH_FAILED,
        GIVE_UP_ERROR_CODES.RESULT_MAPPING_FAILED,
    ],
};

const BUCKET_BY_CODE = Object.fromEntries(
    Object.entries(CODES_BY_BUCKET).flatMap(([bucket, codes]) =>
        codes.map((code) => [code, bucket])
    )
);

export const getFailureBucket = (code) => {
    if (!code) return undefined;

    return BUCKET_BY_CODE[code] ?? FAILURE_BUCKETS.FAILED_OTHER;
};
